/*
 GENERATED FILE - DO NOT MODIFY
 Any changes will be overwritten when `yarn svgs` is executed.
 
 Generated from: assets/open-new-window.svg
 If you need to make changes the attributes, modify the original .svg file.
 
 If you need to modify the file further, consider copying this generated file to a new location,
 or into the component that uses it. If you do this, it might make sense to remove the original .svg file, 
 or it could be regenerated the next time SVGs are generated.
*/
import * as React from 'react';
const OpenNewWindowIcon = React.forwardRef(
  (props: React.SVGProps<SVGSVGElement>, svgRef: any) => (
    <svg
      width={16}
      height={16}
      viewBox="0 0 16 16"
      focusable={false}
      ref={svgRef}
      {...props}
    >
      <g fill="#757676" fillRule="evenodd">
        <path d="M10 0v2h2.719L5 9.637 6.365 11 14 3.305V6h2V0z" />
        <path d="M0 0v16h16V9.989h-2V14H2V2h4V0z" />
      </g>
    </svg>
  ),
);
export default OpenNewWindowIcon;
